// extracted by mini-css-extract-plugin
export default {"wrap":"Faq_wrap__5faS5","line":"Faq_line__jufFL","text":"Faq_text__KYsdg"};